import { useEffect, useRef, useState, Fragment } from 'react';
import { config } from './config';
import { Drawer, Upload, message, Switch, Button } from 'antd';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons'
import {
  SActionBtn,
  SLowcodeList,
  STableActions,
  SMessage,
} from 'shj-components'
import { fileDownload } from '@/utils/download.ts'
import UrlConfig from '@/api/UrlConfigs.ts'
import { getActivityProductList, deleteActivityProduct, getActivityProductDetail, updateActivityProduct, importActivityInfo } from '@/services/product';
import AddOrEditForm from './addOrEdit';
import LimitSet from './limitSet';
import MaterialDetail from './materialDetail';
import _ from 'lodash';

const Material = function (props: any) {
  //id为活动的id
  const { id, show, setVisible, companyList = [] } = props;
  const listRef = useRef<any>();
  const [eid, setEid] = useState(0);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [visibleLimit, setVisibleLimit] = useState(false);
  const [importLoading, setImportLoading] = useState(false)
  const [exportLoading, setExportLoading] = useState(false)
  const [visibleMaterial, setVisibleMaterial] = useState(false);
  const [editData, setEditData] = useState({});

  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, ...rest } = values;
        const where = {};
        //这里需要手动设置一下需要查询使用数量
        where['keyword'] = values.query.keyword;
        where['keyname'] = values.query.keyname;

        getList(where, [current, pageSize], function (records, total) {
          resolve({ records, total });
        });
      } catch (e) {
        console.log(e);
        reject({ success: false });
      }
    });
  };

  const getList = async (data = {}, pages = [1, 10], backFn = (a, b) => ({})) => {
    try {
      const res: any = await getActivityProductList({
        params: {
          pageId: pages[0],
          pageSize: pages[1],
        },
        data: {
          ...data,
          activityId: id,
        },
      });
      const records = res?.list;
      const all = res?.count;
      backFn(records, all);
    } catch (err) {
      console.log(err);
    }
  };
  const onAdd = () => {
    setEid(0);
    setVisibleEdit(true);
    setEditData({});
  };
  const onDelete = async (id: string) => {
    SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await deleteActivityProduct(id);
          if (res.errorCode === 0) {
            message.success(res.message || '删除成功');
            (listRef as any)?.current?.reload();
          } else {
            message.error('删除失败');
          }
        } catch (err) {
          console.log(err)
        }
      },
      onCancel: () => {
        message.warning('取消删除');
      },
    });
  };
  const materialDetailBox = (record: object) => {
    setEid(record.id);
    setVisibleMaterial(true);
  };
  const limitSetBox = (record: object) => {
    setEid(record.id);
    setVisibleLimit(true);
  };

  const editAndAddBox = async (record: any) => {
    const res: any = await getActivityProductDetail(record.id);
    if (res.id) {
      setEditData(res);
      setEid(record.id);
      setVisibleEdit(true);
    }
  };

  const changeStatus = async (status: any, record: any) => {

    const res: any = await updateActivityProduct({
      ...record,
      enabled: status,
    })
    if (res.id) {
      listRef.current.reset();

      message.success('修改成功');
    } else {
      message.error('修改失败');
    }
  };

  const onImport = async (upload: any) => {
    setImportLoading(true)
    const { file, onSuccess, onError } = upload
    const data = new FormData()
    data.append('file', file)
    try {
      const res: any = await importActivityInfo(data, id)
      listRef.current && listRef.current.reload()
      onSuccess && onSuccess()
      if (res?.length) {
        let str = '';
        res.forEach((item, index) => {
          if (item?.errorMessages?.length) {
            str = str + ' ' + `第${item.lineNumber}行` + '、' + item?.errorMessages.join('、')?.slice(0, 100);
          }
        })
        str = str?.slice(0, 300);
        if (str !== '') {
          message.error(str);
        } else {
          message.success(res.message || '导入成功')
        }
      } else {
        message.success(res.message || '导入成功')
      }
      setImportLoading(false)
    } catch (err) {
      setImportLoading(false)
      console.log(err);
    }
  }

  const onExport = async () => {
    try {
      setExportLoading(true)
      await fileDownload(UrlConfig.PlusProductWeb.DownloadActivityInfo)
      setExportLoading(false)
    } catch (err) {
      setExportLoading(false)
      console.log(err);
    }
  }

  const extension = {
    request: { fetchList },
    events: { onAdd },
    customRender: {
      editCell(text: any, record: object) {
        return (
          <Fragment>
            <STableActions>
              <SActionBtn onClick={() => editAndAddBox(record)}>编辑</SActionBtn>
              <SActionBtn title="确认删除该活动?" danger confirm oktext="确认" canceltext="取消" onClick={() => onDelete(record.id)}>删除</SActionBtn>
              {record.activityProductType == 'GROUP' ? (
                <SActionBtn onClick={() => materialDetailBox(record)}>产品明细</SActionBtn>
              ) : (
                ''
              )}
              <SActionBtn onClick={() => limitSetBox(record)}>限量设置</SActionBtn>
            </STableActions>
          </Fragment>
        );
      },
      statusRender(value, record) {
        return (
          <div>
            <Switch checkedChildren="启用" unCheckedChildren="停用" checked={value} onChange={(enable) => changeStatus(enable, record)} />
          </div>
        )
      },
      importRender: () => {
        return (
          <Upload listType="text" customRequest={onImport} itemRender={() => null}>
            <Button
              type={'primary'}
              loading={importLoading}
              disabled={importLoading}
              icon={<UploadOutlined />}
            >
              批量导入
            </Button>
          </Upload>
        )
      },
      exportRender: () => {
        return (
          <Button
            icon={<DownloadOutlined />}
            onClick={onExport}
            disabled={exportLoading}
            loading={exportLoading}
            type="dashed"
          >
            下载导入模板
          </Button>
        )
      },
    },
  };
  const onClose = () => {
    setVisible(false);
  };
  return (
    <Drawer
      title={'活动产品设置'}
      width={'1300px'}
      onClose={onClose}
      bodyStyle={{ padding: 15 }}
      visible={show}
      destroyOnClose={true}
    >
      <SLowcodeList config={{ ...config }} searchMode="group" ref={listRef} {...extension} />
      {
        /**
         * 
              <AddOrEditForm
        editData={editData}
        setVisible={setVisibleEdit}
        show={visibleEdit}
        id={eid}
        pid={id}
        templateType={templateType}
        listRef={listRef}
      />
      <LimitSet setVisible={setVisibleLimit} show={visibleLimit} pid={eid} psid={id} />
      <MaterialDetail setVisible={setVisibleMaterial} show={visibleMaterial} pid={eid} psid={id} />
         */
      }
      {visibleEdit ? <AddOrEditForm
        editData={editData}
        setVisible={setVisibleEdit}
        show={visibleEdit}
        id={eid}
        pid={id}
        listRef={listRef}
      /> : null}
      {visibleLimit ? <LimitSet setVisible={setVisibleLimit} companyList={companyList}  show={visibleLimit} pid={eid} psid={id} /> : null}
      {visibleMaterial ? <MaterialDetail setVisible={setVisibleMaterial} show={visibleMaterial} pid={eid} psid={id} /> : null}
    </Drawer>
  );
};

export default Material;
